export const TEST_ID = 'deviceProvider';
